/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { CREATE_WORKER } from './mutations/playground';
import { UPDATE_LEARNED_ANSWER } from './mutations/request';
import {
  REMOVE_USER_FROM_DEPARTMENT,
  CREATE_DEPARTMENT,
  ROLLBACK_DEPARTMENT,
  UPGRADE_DEPARTMENT,
  UPSERT_USER_TO_DEPARTMENT
} from './mutations/department';
import { CREATE_ORGANIZATION } from './mutations/organization';
import {
  CREATE_PROCEDURE,
  UPDATE_PROCEDURE_SCHEDULE
} from './mutations/process';

const Mutations = {
  // Create a worker
  CreateWorker() {
    return CREATE_WORKER;
  },

  UpdateLearnedAnswer() {
    return UPDATE_LEARNED_ANSWER;
  },

  // Create a procedure
  CreateProcedure() {
    return CREATE_PROCEDURE;
  },

  // Create organization
  CreateOrganization() {
    return CREATE_ORGANIZATION;
  },

  // Create a new department
  CreateDepartment() {
    return CREATE_DEPARTMENT;
  },

  UpgradeDepartment() {
    return UPGRADE_DEPARTMENT;
  },

  RollbackDepartment() {
    return ROLLBACK_DEPARTMENT;
  },

  // Add a user to department as a collaborator
  AddDepartmentCollaborator() {
    return UPSERT_USER_TO_DEPARTMENT;
  },

  // Remove a user from department as a collaborator
  RemoveDepartmentCollaborator() {
    return REMOVE_USER_FROM_DEPARTMENT;
  },

  UpdateProcedureSchedule() {
    return UPDATE_PROCEDURE_SCHEDULE;
  }
};

export default Mutations;
